import { endOfDay, startOfDay, subDays } from 'date-fns';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import {
  PopoverHeader,
  UncontrolledPopover,
} from 'reactstrap';
import Select from '../../components/form/select';
import {
  getReceiptDashboardInfo,
  getUsersForRankings,
  setDashboardInboundOrdersDates,
  setSelectedUserBranches,
} from '../../app/store/actions/productivityRanking';
import { getOrdersTypeOptions } from '../../app/store/actions/typeOrder';

import DateRangePicker from '../../components/date/DateRangePicker.jsx';
import OneClickButton from '../../components/form/button';
import FilterSelectionList from '../../components/form/filterSelectionList';
import Table from '../../components/table/Table';
import FormatHelpers from '../../helpers/format';

import BarChart from '../../components/charts/BarChart';

class ReceiptProductivityRankingDashboard extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      defaultSorted: [{
        id: 'rank',
        desc: false,
      }],
      typeDashboard: 'Order',
      typeGrid: 'Conference',
      rankingCriterion: 'ordersQty',
      rankingOptions: [],
    };

    this.tableColumns = [
      {
        Header: I18n.t('BEE4480' /* Ranking */),
        accessor: 'rank',
        style: { alignSelf: 'center', textAlign: 'center' },
        width: 90,
      }, {
        Header: I18n.t('BEE4481' /* Cód. Colaborador */),
        accessor: 'employeeCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4482' /* Qtd. Documentos */),
        accessor: 'ordersQty',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 140,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4483' /* Qtd. SKU */),
        accessor: 'SKUQty',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE3604' /* Qtd Caixas */),
        accessor: 'boxQty',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4487' /* Qtd. Peso */),
        accessor: 'weightQty',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4484' /* Valor Financeiro (R$) */),
        accessor: 'financialValue',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 160,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 2, true),
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4485' /* Endereços Visitados */),
        accessor: 'visitedAddresses',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE2532' /* Tempo médio por documento (em horas) */),
        accessor: 'averageTimePerDoc',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 300,
        Filter: this.filterColumn,
      },
    ];

    this.state.rankingOptions = this.tableColumns
      .filter((c) => c.accessor && (c.accessor !== 'rank' && c.accessor !== 'employeeCode'))
      .map((c) => ({ value: c.accessor, label: c.Header }));

    this.breadcrumb = [
      { value: I18n.t('BEE42' /* Dashboard */), iconClassName: 'fa fa-chart-line m-t-10 m-r-5' },
      { value: I18n.t('BEE36' /* Recebimento */) },
      { value: I18n.t('BEE4472' /* Ranking de Produtividade */), active: true },
    ];
  }

  async componentDidMount() {
    if (!this.props.location.state || !Object.keys(this.props.location.state).length) {
      const startDate = moment().subtract(30, 'd');
      const endDate = moment();
      const dates = { startDate, endDate };

      await this.props.setDashboardInboundOrdersDates(dates);

      await this.getInboundOrders();

      const listOrderTypes = await this.props.getOrdersTypeOptions();
      const listUsers = await this.props.getUsersForRankings();

      this.setState({
        listOrderTypes,
        listUsers,
      });
    }

    this.props.history.push({
      state: {},
    });
  }

  filterColumn = ({ onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (event.target.value === '' && (event.keyCode === 8 || event.which === 8)) {
          onChange(event.target.value);
        }
      }}
    />
  );

  getInboundOrders = async () => {
    const {
      startDate, endDate,
    } = this.props.dates;

    const branchesToSearch = [];
    if (this.props.selectedBranches) {
      this.props.selectedBranches.forEach(({ value }) => branchesToSearch.push(value));
    }

    const orderTypesToSearch = [];
    if (this.state.selectedOrderTypes) {
      this.state.selectedOrderTypes.forEach(({ value }) => orderTypesToSearch.push(value));
    }

    const usersToSearch = [];
    if (this.state.selectedUsers) {
      this.state.selectedUsers.forEach(({ value }) => usersToSearch.push(value));
    }

    await this.props.getReceiptDashboardInfo(
      startDate,
      endDate,
      true,
      branchesToSearch,
      orderTypesToSearch,
      usersToSearch,
      this.state.typeDashboard,
    );
  };

  computeRanks = (data = [], criterion) => {
    if (!Array.isArray(data)) return [];

    const ascendCriteria = ['averageTimePerDoc'];
    const sortDirection = ascendCriteria.includes(criterion) ? 'asc' : 'desc';

    const sorted = _.orderBy(data, [(item) => {
      const v = _.get(item, criterion);
      const n = Number.isFinite(Number(v)) ? Number(v) : null;
      return n !== null ? n : _.lowerCase(String(v || ''));
    }], [sortDirection]);

    const rankMap = {};
    sorted.forEach((item, idx) => {
      rankMap[item.id] = idx + 1;
    });

    return data.map((item) => ({ ...item, rank: rankMap[item.id] || null }));
  };

  handleDateApplyEvent = async (value) => {
    const startDate = value[0];
    const endDate = value[1];

    const dates = { startDate, endDate };
    await this.props.setDashboardInboundOrdersDates(dates);
  };

  handleBranchesSelected = async (event) => {
    const selectedBranches = [];

    event.forEach((element) => selectedBranches.push({
      value: element.value,
      label: element.label,
    }));

    await this.props.setSelectedUserBranches(selectedBranches);
  };

  handleOrderTypesSelected = async (event) => {
    const selectedOrderTypes = [];

    event.forEach((element) => selectedOrderTypes.push({
      value: element.value,
      label: element.label,
    }));

    this.setState({
      selectedOrderTypes,
    });
  };

  handleUsersSelected = async (event) => {
    const selectedUsers = [];

    event.forEach((element) => selectedUsers.push({
      value: element.value,
      label: element.label,
    }));

    this.setState({
      selectedUsers,
    });
  };

  handleTypeDashboard = async (type) => {
    if (this.state.typeDashboard !== type) {
      this.setState({
        typeDashboard: type,
      });
    }
  };

  handleTypeGrid = async (type) => {
    if (this.state.typeGrid !== type) {
      this.setState({
        typeGrid: type,
      });
    }
  };

  render() {
    const {
      defaultSorted, listOrderTypes, listUsers, typeDashboard, rankingCriterion, rankingOptions, typeGrid,
    } = this.state;

    const startDate = (this.props.dates && this.props.dates.startDate) || startOfDay(subDays(new Date(), 30));
    const endDate = (this.props.dates && this.props.dates.endDate) || endOfDay(new Date());
    const { conferenceRankings = [], storageRankings = [] } = this.props;

    let processedRankings = [];

    if (typeGrid === 'Conference') {
      processedRankings = this.computeRanks(conferenceRankings, rankingCriterion);
    } else if (typeGrid === 'Storage') {
      processedRankings = this.computeRanks(storageRankings, rankingCriterion);
    }

    const colorStyles = {
      control: (styles) => ({ ...styles, backgroundColor: 'white' }),
      option: (styles, {
        data, isDisabled, isFocused, isSelected,
      }) => ({
        ...styles,
        backgroundColor: isDisabled ? 'grey' : 'white',
        color: isDisabled ? 'grey' : 'black',
        cursor: isDisabled ? 'not-allowed' : 'default',
        textAlign: 'left',

        ':hover': {
          ...styles[':hover'],
          backgroundColor: isSelected ? 'grey' : '#eb900a',
          color: 'white',
        },
      }),
    };

    return (
      <div>
        {!!this.breadcrumb && this.breadcrumb.length && (
          <div className="d-flex align-items-center">
            <ol className="breadcrumb float-xl-left">
              {this.breadcrumb.map((it, index) => (
                <li key={`${it.value}${index}`} className={`breadcrumb-item${it.active ? ' active' : ''}`}>
                  {
                    it.iconClassName
                      ? (
                        <>
                          <i className="fa fa-chart-line m-t-10 m-r-5" />
                          {' '}
                          {it.value}
                        </>
                      ) : (
                        it.value
                      )
                  }
                </li>
              ))}
            </ol>
          </div>
        )}
        <div className="d-flex align-items-center">
          <h1 className="page-header mb-0">
            {I18n.t('BEE4472' /* Ranking de Produtividade */)}
          </h1>
        </div>
        <div className="d-sm-flex mb-2">
          <div className="d-flex mt-2">
            <DateRangePicker
              onChange={(value) => {
                this.handleDateApplyEvent(value);
              }}
              defaultValue={[new Date(startDate), new Date(endDate)]}
            />
            <UncontrolledPopover trigger="hover" placement="top" target="dateRangePicker">
              <PopoverHeader>
                {I18n.t('BEE3342', {
                  0: (I18n.t('BEE4492' /* data de execução */)),
                } /* O intervalo segue o critério pela %{0} */)}
              </PopoverHeader>
            </UncontrolledPopover>
          </div>
          <div className="d-flex mt-2">
            <FilterSelectionList
              value={this.props.selectedBranches}
              onChangeValue={this.handleBranchesSelected}
              placeholderValue={I18n.t('BEE2424' /* Todas as filiais estão selecionadas */)}
              optionsValue={this.props.userBranches}
              onClickValue={this.getInboundOrders}
            />
          </div>
          <div className="d-flex mt-2 ml-1">
            <FilterSelectionList
              value={this.state.selectedUsers}
              onChangeValue={this.handleUsersSelected}
              placeholderValue={I18n.t('BEE4473' /* Todos os usuários estão selecionados */)}
              optionsValue={listUsers}
              onClickValue={this.getInboundOrders}
            />
          </div>
          <div className="d-flex mt-2 ml-1">
            <FilterSelectionList
              value={this.state.selectedOrderTypes}
              onChangeValue={this.handleOrderTypesSelected}
              placeholderValue={I18n.t('BEE3355' /* Todos os tipos de documentos estão selecionados. */)}
              optionsValue={listOrderTypes}
              onClickValue={this.getInboundOrders}
            />
          </div>
        </div>
        <div>
          <OneClickButton
            type="button"
            className={
              `btn btn-120 ${typeDashboard === 'Order' ? 'btn-primary' : 'btn-white'} btn-rounded p-5 m-5`
            }
            onClick={() => this.handleTypeDashboard('Order')}
          >
            {I18n.t('BEE2559' /* Por Documento */)}
          </OneClickButton>
          <OneClickButton
            type="button"
            className={`btn btn-120 ${typeDashboard === 'Product' ? 'btn-primary' : 'btn-white'} btn-rounded p-5 m-5`}
            onClick={() => this.handleTypeDashboard('Product')}
          >
            {I18n.t('BEE2560' /* Por Linha */)}
          </OneClickButton>
        </div>
        <div className="row">
          <div className="col-xl-6">
            {typeDashboard === 'Order' && (
              <BarChart
                key={`Conference|${typeDashboard}`}
                barChartValues={this.props.checkedOrdersColumnChart}
                height={450}
                isVerticalBar
                formatToQuantity
                useFormatter
                title={I18n.t('BEE4491' /* Total de Conferências por Mês */)}
              />
            )}
            {typeDashboard === 'Product' && (
              <BarChart
                key={`Conference|${typeDashboard}`}
                barChartValues={this.props.checkedProductsColumnChart}
                height={450}
                isVerticalBar
                formatToQuantity
                useFormatter
                title={I18n.t('BEE4491' /* Total de Conferências por Mês */)}
              />
            )}
          </div>
          <div className="col-xl-6">
            {typeDashboard === 'Order' && (
              <BarChart
                key={`Storage|${typeDashboard}`}
                barChartValues={this.props.storedOrdersColumnChart}
                height={450}
                isVerticalBar
                formatToQuantity
                useFormatter
                title={I18n.t('BEE4495' /* Total de Armazenamentos por Mês */)}
              />
            )}
            {typeDashboard === 'Product' && (
              <BarChart
                key={`Storage|${typeDashboard}`}
                barChartValues={this.props.storedProductsColumnChart}
                height={450}
                isVerticalBar
                formatToQuantity
                useFormatter
                title={I18n.t('BEE4495' /* Total de Armazenamentos por Mês */)}
              />
            )}
          </div>
        </div>
        <div className="ml-3">
          <div className="row mb-1">
            <OneClickButton
              type="button"
              className={
                `btn btn-120 ${typeGrid === 'Conference' ? 'btn-primary' : 'btn-white'} btn-rounded p-5 m-5`
              }
              onClick={() => this.handleTypeGrid('Conference')}
            >
              {I18n.t('BEE4490' /* Por Conferência */)}
            </OneClickButton>
            <OneClickButton
              type="button"
              className={`btn btn-140 ${typeGrid === 'Storage' ? 'btn-primary' : 'btn-white'} btn-rounded p-5 m-5`}
              onClick={() => this.handleTypeGrid('Storage')}
            >
              {I18n.t('BEE4496' /* Por Armazenamento */)}
            </OneClickButton>
          </div>
          <div className="row">
            <div className="d-flex justify-content-start mb-2 align-items-center ml-1">
              <label className="m-2 col-form-label" style={{ fontSize: 14 }}>
                <strong>
                  {I18n.t('BEE4480' /* Ranking */)}
                  :
                </strong>
              </label>
              <div className="ml-1" style={{ minWidth: 300 }}>
                <Select
                  value={(rankingOptions.find((o) => o.value === rankingCriterion)) || ''}
                  onChange={(e) => this.setState({ rankingCriterion: e.value })}
                  options={rankingOptions}
                  isClearable={false}
                  closeMenuOnSelect
                  blurInputOnSelect={false}
                  isSearchable
                  styles={colorStyles}
                  maxMenuHeight={200}
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <Table
            key={`ranking-${rankingCriterion}`}
            downloadCSV
            onClickCollapse
            panelHeaderProps={{
              onClickReload: () => this.getInboundOrders(),
              pageDescription: I18n.t('BEE4480' /* Ranking */).toUpperCase(),
            }}
            filterable
            data={processedRankings}
            columns={this.tableColumns}
            expander
            defaultPageSize={10}
            defaultSorted={defaultSorted}
            defaultFilterMethod={(filter, row) => {
              const input = _.lowerCase(filter.value);
              const value = _.lowerCase(row[filter.id]);
              if (_.includes(value, input)) {
                return true;
              }
            }}
            noDataText={I18n.t('BEE2423' /* Não há dados na data informada */)}
            getTrProps={(state, rowInfo) => {
              if (rowInfo && rowInfo.row) {
                return {
                  style: {
                    background: 'white',
                    cursor: 'pointer',
                  },
                };
              }
              return {};
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userBranches: state.rankings.userBranches,
  dates: state.rankings.dates,
  selectedBranches: state.rankings.selectedBranches,
  checkedOrdersColumnChart: state.rankings && state.rankings.chartsPanel.checkedOrdersColumnChart,
  checkedProductsColumnChart: state.rankings && state.rankings.chartsPanel.checkedProductsColumnChart,
  storedOrdersColumnChart: state.rankings && state.rankings.chartsPanel.storedOrdersColumnChart,
  storedProductsColumnChart: state.rankings && state.rankings.chartsPanel.storedProductsColumnChart,
  conferenceRankings: state.rankings && state.rankings.conferenceRankings,
  storageRankings: state.rankings && state.rankings.storageRankings,
});

const mapDispatchToProps = (dispatch) => ({
  getReceiptDashboardInfo:
    (
      startDate,
      endDate,
      getCharts,
      selectedBranches,
      selectedOrderTypes,
      selectedUsers,
      typeDashboard,
    ) => dispatch(getReceiptDashboardInfo(
      startDate,
      endDate,
      getCharts,
      selectedBranches,
      selectedOrderTypes,
      selectedUsers,
      typeDashboard,
    )),
  setSelectedUserBranches: (selectedBranches) => dispatch(setSelectedUserBranches(selectedBranches)),
  getOrdersTypeOptions: () => dispatch(getOrdersTypeOptions()),
  getUsersForRankings: () => dispatch(getUsersForRankings()),
  setDashboardInboundOrdersDates: (dates) => dispatch(setDashboardInboundOrdersDates(dates)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReceiptProductivityRankingDashboard));
